<template>
  <div class="border-bg introduce">
    <div class="title-style">
      <div class="title-box">指数介绍</div>
    </div>
    <div class="introduce-container" v-if="introduce.content">
      <vue3-seamless-scroll :list="list" class="scroll" :step="0.3">
        <div class="item" v-for="item in list" :key="item" v-html="introduce.content">
        </div>
      </vue3-seamless-scroll>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { articleId } from '@/utils/data.js'
import { getArticle, getArticleList } from '@/api/article.js'

const list = ref([1, 2, 1, 2, 1, 2, 1, 1, 1])
// 指数介绍id
const introduceId = ref(articleId.introduceId)
// 指数介绍数据
const introduce = ref({})
/** 获取指数介绍 */
const getIntroduce = () => {
  getArticleList({
    typeId: introduceId.value,
    pageNo: 1,
    pageSize: 1
  }).then(res => {
    if (res.data.length > 0) {
      getArticle(res.data[0].id).then(response => {
        introduce.value = response.data
      })
    }
  })
}

getIntroduce()
</script>

<style lang="scss" scoped>
.introduce{
  padding: 10px;
  .introduce-container{
    height: 230px;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.introduce{
  .introduce-container{
    margin-top: 5px;
    height: 230px;
    overflow: hidden;
    p{
      line-height: 25px !important;
    }
    span{
      font-size: 14px !important;
      font-family: PingFangSC !important;
    }
    img{
      width: 100%;
    }
  }
}
</style>
